// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { xai as _xai } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the xai chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 660279
 * Chain Name: Xai Mainnet
 * Default Block Explorer: https://explorer.xai-chain.net
 * Default RPC URL: https://xai-chain.net/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { xai } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: xai,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const xai = createCommon({
	..._xai,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
